<template>
  <div class="ourStory">
    <quote
      >Du triffst 1000 Menschen und keiner berührt dich. Und dann kommt einer.
      Und verändert alles.</quote
    >
    <div class="startingStory">
      <v-card
        v-for="(person, i) in people"
        :key="i"
        class="elevation-2 colored-background-on-hover person-story"
      >
        <v-card-title class="headline space-between"
          >{{ person.title
          }}<span class="overline when">{{ person.birth }}</span></v-card-title
        >
        <v-card-text class="person-text-wrapper"
          ><span class="person-text">{{ person.text }}</span>
          <v-img
            :src="person.image"
            class="floating-image"
            min-width="20%"
            max-width="200px"
          />
        </v-card-text>
      </v-card>
    </div>
    <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
      <v-timeline-item
        v-for="(event, i) in timeline"
        :key="i"
        :color="event.color"
        fill-dot
        :icon="event.icon"
        large
      >
        <template v-slot:opposite>
          <div v-if="event.image" class="event-image">
            <v-img
              :src="event.image"
              max-width="100%"
              max-height="300px"
              contain
            />
          </div>
        </template>
        <v-card class="elevation-2 colored-background-on-hover event-story">
          <v-card-title class="headline space-between"
            >{{ event.title }}
            <span class="overline when">{{ event.when }}</span></v-card-title
          >
          <v-card-text>
            {{ event.text }}
            <div
              v-if="event.image && $vuetify.breakpoint.smAndDown"
              class="event-image"
            >
              <v-img
                :src="event.image"
                max-width="100%"
                max-height="300px"
                contain
              />
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>
<style scoped>
.ourStory {
  padding: 10px;
  /* IE11 fix */
  max-width: 100vw;
}
.floating-image {
  float: right;
}
.space-between {
  justify-content: space-between;
}
.person-story {
  flex-grow: 1;
  width: 400px;
  margin: 10px;
}
.person-text-wrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.person-text {
  width: 60%;
  flex-grow: 1;
}
.startingStory {
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
}
.when {
  background: hsla(193, 100%, 55%, 0.3);
  padding: 10px;
  border-radius: 5px;
}
.colored-background-on-hover:hover {
  background: #1acdff;
}
.colored-background-on-hover {
  transition: background 2s;
}
</style>

<script>
import Quote from "../app/Quote";
export default {
  name: "ourStory",
  components: { Quote },
  data: () => ({
    people: [
      {
        title: "Die Melina",
        birth: "15. Februar 1991",
        image: "images/1996-Melina.jpg",
        text:
          "Melina Breuer kommt am 15.02.1991 um 04:00 Uhr im Krankenhaus Laichingen zur Welt. Mit ihrer drei Jahre jüngeren Schwester wächst sie in Merklingen auf. Das Gerätturnen ist beim TV Merklingen, zusammen mit ihrer Schwester, von klein auf ihr Lieblingssport. Die Leistungsgruppe kombiniert Turnen mit Hip-Hop Tanz. Melina nimmt jahrelang an Wettkämpfen und Aufführungen in der Gemeinde und im Ulmer Theater teil. Sie macht die Ausbildung zur Kampfrichterin und sitzt vormittags noch im Kampfgericht, während sie nachmittags selbst einen Wettkampf turnt. Als der Zeitmangel in den Abiturvorbereitungen das immer härter werdende Training nicht mehr zulässt, steigt sie ganz auf Tennis um. In ihrer Schulzeit lernt sie das Keyboardspielen. Melina liebt das Tennisspielen, Zeichnen, Lesen und Backen.",
        keywords: [
          "Langschläferin",
          "Sauberkeitsfanatikerin",
          "Backkünstlerin",
          "Zeichnerin",
          "Tennisspielerin",
          "Leserin",
          "pünktlich",
          "warmherzig",
          "reisefreudig"
        ]
      },
      {
        title: "Der Koni",
        birth: "14. November 1989",
        image: "images/2003-12-14-Koni.jpg",
        text:
          'Frühmorgens um 1:58 Uhr kam der kleine schreiende Konstantin Helmut Grupp im Laichinger Krankenhaus zur Welt. Bestens umsorgt von seinen drei älteren Schwestern wuchs er in Westerheim auf. Schnell spiegelte sich der Spitzname Koni (gesprochen Konni) heraus. Koni ging ins Turnen, später spielte er Fußball und Tischtennis, bis er dann im Volleyball ankam. Auf der musikalischen Seite lernte er Akkordeon spielen. Über viele Jahre war er Ministrant und beteiligte sich an der Jugendarbeit der katholischen Kirchengemeinde Westerheim. Nach der Devise, "was ich mache habe ich dann auch", wurde so ein eigenes Häuschen in den Garten gestellt. Stets technisch interessiert war auch der erste Familiencomputer eine zentrale Anlaufstelle.',
        keywords: [
          "Frühaufsteher",
          "Aufräumer",
          "ehrgeizig",
          "Volleyballer",
          "Romantiker",
          "Gamer",
          "Handwerker",
          "Informatiker",
          "Hilfsbereit",
          "Brettspieleliebhaber"
        ]
      }
    ],
    timeline: [
      {
        color: "#fba86a",
        icon: "warning",
        title: "Der Feueralarm",
        when: "September 2008",
        text:
          "Morgens, Schule, Kälte! Mal wieder ein Probefeueralarm und alle müssen raus auf den Hartplatz am Schwimmbad. Nach einigen Minuten frieren, weil man die Jacke doch nicht mitgenommen hatte, geht es wieder zurück in den Neubau des Albert-Schweitzer-Gymnasiums. Auf der Treppe nach oben hat Koni den Mut und spricht Melina an."
        // TODO add picture "Treppe ASG Cube"
      },
      {
        color: "#e5caba",
        icon: "emoji_people",
        title: "Die Heizung",
        when: "Oktober 2008 - Januar 2009",
        text:
          'Der erste Kontakt war gemacht, über die nächsten Monate war der gemeinsame Treffpunkt die "Oberstufenheizung". Hier unterhielten wir uns meist in der Mittagspause und lernten uns so besser kennen.'
      },
      {
        color: "#ff6961",
        icon: "local_bar",
        title: "Abiparty und Konis Geburtstag",
        when: "14. November 2008",
        image: "images/2008-11-14-Abiparty-Jasmin.jpg",
        imageAlt: "Erstes gemeinsames Bild von Koni & Melina",
        text:
          "Koni war bereits in den Abiturvorbereitungen. Dazu gehören natürlich auch die Abipartys. Am Freitag den 14. November findet diese statt und Melina ist mit am Start. Für sie war die Sache klar, Koni hatte leider das Gefühl, dass sie ihn nicht so richtig mochte. Somit sollte es zum Glück noch dauern."
      },
      {
        color: "#f6f296",
        icon: "cake",
        title: "Der Geburtstag",
        when: "15. Februar 2009",
        text:
          "Melina feierte ihren 18. Geburtstag bei sich im Keller. Die Anspannung war auf beiden Seiten groß. Was für alle anderen Freunde schon allzu lange offensichtlich war, hatten wir noch nicht so richtig realisiert."
      },
      {
        color: "amber",
        icon: "local_bar",
        title: "Der Glombige Doschdeg",
        when: "19. Februar 2009",
        text:
          'Damit es nun wirklich funktionierte brauchte es den ein oder anderen Mutmacher und gute Tanzstimmung. Der Glombige Doschdeg in der Westerheimer Albhalle war dazu bestens geeignet wie sich herausstellte. Koni war der Überzeugung heute muss er den Mut aufbringen. So tanzten wir eine ganze Weile Hand in Hand und es folgte ein Kuss. Später saßen wir Arm in Arm und eine Freundin fragte Melina ob wir zusammen sind. Sie sagt einfach "JA" und endlich hatte Koni sein Ziel erreicht.'
      },
      {
        color: "#8ef58f",
        icon: "emoji_events",
        title: "Konis Abitur",
        when: "1. April 2009",
        image: "images/2009-Melina-Handy.jpg",
        imageAlt: "Melina & Koni in der Bude",
        text:
          "Für Koni stand im selben Jahr noch das Abitur an. Abgelenkt von ihr war es schwer sich auf das Lernen zu fokussieren, aber am Ende funktionierte es dann trotzdem irgendwie. Am 1. April war dann das schriftliche Abitur geschrieben und die Zeit des Feierns brach an. So waren wir zusammen mit Frank, Chrissi und Tobias in der Bude und verbrachten dort den ganzen restlichen Tag."
      },
      {
        color: "#6d7afb",
        icon: "directions_railway",
        title: "Ab in die Ferne",
        when: "7. September 2009",
        text:
          "Melina hatte noch ein Jahr Schule vor sich. Für Koni stand direkt der Zivildienst an. Nach längerem Überlegen nahm er so die Stelle zum Freiwilligen Ökologischen Jahr beim bischöflichen Bauamt in Rottenburg an. Damit startete eine etwas zu lang dauernde Fernbeziehung."
      },
      {
        color: "#a51e37",
        icon: "school",
        title: "Konis Informatikstudium",
        when: "Oktober 2010",
        text:
          "Koni zieht nach Tübingen, um dort an der Universität Informatik zu studieren. Der Bachelorstudiengang dauert 3 Jahre."
      },
      {
        color: "#e6c3be",
        icon: "menu_book",
        title: "Melinas Ausbildung",
        when: "September 2011",
        text:
          "Melina beginnt ihre Ausbildung zur medizinischen Fachangestellten in Heroldstatt. Die Ausbildung dauert 3 Jahre."
      },
      {
        color: "#87c6e0",
        icon: "flight_takeoff",
        title: "Erster großer Urlaub",
        when: "August 2012",
        image: "images/2012-08-20-Quer-durch-Mallorca.jpg",
        imageAlt: "Koni & Lina in Mallorca",
        text:
          "Unser erstes großes Urlaubsziel war Mallorca. Im August 2012 haben wir uns für 7 Tage auf die Reise gemacht. Auf der Tagesordnung stand Chillen am Strand. Wie es der Zufall aber so will, trifft man am Strand auf Mallorca die liebe Familie. Da das Abhängen sowieso schnell langweilig wurde, planten wir zusammen mit Vero und Chris für den nächsten Tag einen Ausflug mit dem Auto quer über die Insel. Von da an haben wir einiges von dieser schönen Insel gesehen. "
      },
      {
        color: "#a51e37",
        icon: "school",
        title: "Konis Masterstudium",
        when: "Oktober 2013",
        text:
          "Koni schließt sein Bachelorstudium ab. Gleich im Anschluss daran macht er mit dem Masterstudium in Informatik weiter. Das Studium dauert nochmal 2 Jahre. Der Wunsch nach einer gemeinsamen Wohnung kommt auf und wächst. "
      },
      {
        color: "#000099",
        icon: "school",
        title: "Melinas Bachelorstudium",
        when: "Oktober 2014",
        text:
          "Melina schließt ihre Ausbildung im Mai erfolgreich ab. Zum ersten Mal wird der Plan für eine gemeinsame Wohnung ernsthaft diskutiert und in Erwägung gezogen. Melina bewirbt sich nebenbei auf den Bachelorstudiengang Gesundheitspädagogik an der PH in Freiburg und wird angenommen. Im Oktober 2014 zieht sie nach Freiburg, für 3 Jahre."
      },
      {
        color: "#a71417",
        icon: "laptop",
        title: "Konis Start ins Arbeitsleben",
        when: "April 2016",
        image: "images/2018-12-XX-Weihnachtsfeier-itdesign.jpg",
        imageAlt: "Koni & Lina bei itdesign",
        text:
          "Koni beendet mit dem Titel Master of Science erfolgreich sein Informatikstudium. Er kommt zurück nach Westerheim und zieht übergangsweise wieder bei seinen Eltern ein. Er tritt seine erste Stelle als Softwareentwickler bei itdesign in Tübingen an und pendelt jeden Tag von Westerheim zur Arbeit."
      },
      {
        color: "#80ff80",
        icon: "search",
        title: "Wohnungssuche",
        when: "Frühjahr 2017",
        text:
          "Der Plan in eine gemeinsame Wohnung zu ziehen ist noch immer aktuell. Immer wieder werden Möglichkeiten diskutiert und besprochen. Koni kauft in Laichingen eine Wohnung für uns beide, diese muss aber erst noch fertiggestellt werden. Melina ist derzeit im 6. Semester und hat nur wenige Vorlesungen, da sie viel Zeit in ihre Bachelorarbeit investieren sollte. Eine Zeit, die man eigentlich auch besser nutzen kann. Angebote für eine Übergangswohnung finden wir bei unseren Familien. Netterweise kommt uns Melinas Tante Hildegard entgegen, indem sie uns für ein Jahr die Wohnung im ersten Stock überlässt."
      },
      {
        color: "#c01e2d",
        icon: "home",
        title: "Einzug in die gemeinsame Wohnung in Merklingen",
        when: "26. Mai 2017",
        text:
          "So gut es geht und mit viel Provisorien wird die Wohnung eingerichtet. Am 26.05.2017 ist es so weit und wir können in unsere erste gemeinsame Wohnung einziehen. Melina ist weiterhin an 2 – 3 Tagen unter der Woche in Freiburg. Eine klare Aufgabenverteilung stellt sich schnell heraus, da sich die Vorlieben wunderbar ergänzen."
      },
      {
        color: "#0d9cd8",
        icon: "work",
        title: "Melinas Start ins Arbeitsleben",
        when: "November 2017",
        text:
          "Melina beendet als B.Sc. Gesundheitspädagogin erfolgreich ihr Bachelorstudium in Freiburg und zieht nun ganz in die gemeinsame Wohnung in Merklingen ein. Sie startet beim Internationalen Bund in Geislingen als Pädagogische Mitarbeiterin in den Freiwilligendiensten."
      },
      {
        color: "#ffc900",
        icon: "home",
        title: "Einzug in die eigene Wohnung in Laichingen",
        when: "05. Mai 2018",
        image: "images/2018-05-13-Herz-auf-Sofa.jpg",
        imageAlt: "Unsere neue Wohnung",
        text:
          "New Home, New Adventures, New Memories. Nach Fertigstellung können wir mit etwas Verspätung in unsere neue Wohnung in Laichingen einziehen."
      },
      {
        color: "#1acdff",
        icon: "favorite",
        title: "Skiurlaub in Warth",
        when: "18. – 20. Februar 2019",
        image: "images/2019-02-19-Skiurlaub-Warth.jpg",
        imageAlt: "Der Verlobungsring",
        text:
          "Anlässlich des 10. Jahrestages wollen wir gemeinsam wegfahren. Koni möchte sich um den Kurzurlaub kümmern und macht zwei Vorschläge für das Urlaubsziel: Städtetrip nach Paris oder Skiurlaub in den Bergen. Melina hat von Konis eigentlichen Plänen keine Ahnung und entscheidet sich für den Skiurlaub. Am 18.02. kommen wir zur Mittagszeit an der Jägeralpe in Warth am Arlberg an, die Skier werden angeschnallt und los geht’s. Während Melina ganz mit sich und ihren Skiern beschäftigt ist, gehen Koni ganz andere Dinge durch den Kopf. Nach der letzten Abfahrt geht’s ins Hotel Schwarzer Adler in Steeg. Koni reserviert sofort und mit Nachdruck an der Rezeption einen Platz im Restaurant. Melina merkt Konis Anspannung und versucht ihn zu beruhigen, dass später ganz sicher noch ein Platz frei sein wird und sie ihr wohlverdientes Schnitzel verspeisen können. Nach einer heißen Dusche und in frischen Klamotten sehen wir uns den Sonnenuntergang in den Bergen vom Hotelzimmer aus an. In romantischer Atmosphäre macht Koni mit einer schönen Liebeserklärung, einem Kniefall und einem Ring Melina einen Antrag. Und sie sagt total überwältigt „JA“."
      },
      {
        color: "#7a0f1e",
        icon: "all_inclusive",
        title: "Standesamtliche Trauung",
        when: "20. Dezember 2019",
        image: "images/2019-12-20-Standesamtliche-Hochzeit.jpg",
        imageAlt: "Standesamtliche Trauung",
        text:
          "Genau sechs Monate vor unserem großen Fest haben wir bereits den nächsten Schritt getan und uns vor Staat und Familie das JA-Wort gegeben."
      }
    ]
  })
};
</script>
